module.exports = __webpack_public_path__ + "img/BDVT Online Trainer.1d350fa8.jpg";